import { jsx as _jsx } from "react/jsx-runtime";
import SortableJS from 'sortablejs';
import { useEffect, useRef } from 'react';
import { sortDataAccordingItemMovement } from './utils';
export const Sortable = ({ container, children, options, data, onSortEnd: onSortEndCb, }) => {
    const ref = useRef(null);
    const onSortEnd = (event) => {
        if (!onSortEndCb || !(data === null || data === void 0 ? void 0 : data.length)) {
            return;
        }
        const newData = sortDataAccordingItemMovement(event, data);
        if (newData) {
            onSortEndCb(newData);
        }
    };
    useEffect(() => {
        const sortableParentContainer = container || ref.current;
        if (!sortableParentContainer) {
            console.error('No sortable container found');
            return;
        }
        new SortableJS(sortableParentContainer, Object.assign({ animation: 150, handle: '.sortable-handle', draggable: '.sortable-record', onSort: onSortEnd }, options));
    }, [container]);
    return _jsx("div", { ref: ref, children: children });
};
